import React from "react";
import { Link } from "react-router-dom";
import Header from "../Header/Header";
import BlogPosts from "../BlogPosts/BlogPosts";
import GameModes from "../GameModes/GameModes";
import ScoreBoard from "../ScoreBoard/ScoreBoard";
import AboutUs from "../AboutUs/AboutUs";
import Footer from "../Footer/Footer";

import Main from "../Main/Main";
import MainTitle from "../MainTitle/MainTitle";
export default function Home() {
  return (
    <>
      <Header></Header>
      <Main></Main>
      <BlogPosts></BlogPosts>
      <GameModes></GameModes>
      <ScoreBoard></ScoreBoard>
      <AboutUs></AboutUs>
      <Footer></Footer>
    </>
  );
}
